module.exports = __webpack_public_path__ + "img/37.5.COD.8fab7aeb.png";